import { render, staticRenderFns } from "./transactionPopup.vue?vue&type=template&id=316b0536&scoped=true"
import script from "./transactionPopup.vue?vue&type=script&lang=js"
export * from "./transactionPopup.vue?vue&type=script&lang=js"
import style0 from "./transactionPopup.vue?vue&type=style&index=0&id=316b0536&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316b0536",
  null
  
)

export default component.exports